/* wellinda-percents — review slider beside the stats.
   The track is a native scroll-snap rail, so swiping works on touch; the arrows
   and dots only scroll it, and the current slide is read back from the scroll
   position. Self-contained: only touches elements inside its own section. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.wpercReady === 'true') return;
    root.dataset.wpercReady = 'true';

    var track = root.querySelector('[data-wperc-track]');
    var slides = root.querySelectorAll('[data-wperc-slide]');
    var prev = root.querySelector('[data-wperc-prev]');
    var next = root.querySelector('[data-wperc-next]');
    var dots = root.querySelectorAll('[data-wperc-dot]');
    if (!track || slides.length < 2) return;

    function current() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function goTo(index) {
      var i = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: i * track.clientWidth });
    }

    function sync() {
      var i = current();
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
      for (var d = 0; d < dots.length; d++) {
        var on = d === i;
        dots[d].classList.toggle('is-active', on);
        dots[d].setAttribute('aria-current', on ? 'true' : 'false');
      }
    }

    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });

    for (var k = 0; k < dots.length; k++) {
      dots[k].addEventListener('click', function () {
        goTo(Number(this.getAttribute('data-wperc-dot')));
      });
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        sync();
      });
    }, { passive: true });

    window.addEventListener('resize', sync);
    sync();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-wperc-slider]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // the theme editor re-renders sections on edit
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-wperc-slider]');
    if (root) init(root);
  });
})();
